import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import CountryPhoneInput from '@root/core/components/CountryPhoneInput';
import { placesAutocomplete } from '@root/utils/helpers/placesAutocomplete';
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Spin,
  Upload,
  UploadProps
} from 'antd';
import { UploadFile } from 'antd/es/upload/interface';
import React, { useEffect, useRef, useState } from 'react';
import useOnclickOutside from 'react-cool-onclickoutside';
import { AutocompletePrediction } from 'react-places-autocomplete';
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng
} from 'use-places-autocomplete';

import '../../../../core/components/CountryPhoneInput/meta-service';

import signUpServices from '../../../Authentication/SignUp/services/sign-up';

import pageWarehouseService from '../services/mypageWare';

const { Option } = Select;
const MAJOR_PRODUCT_TYPE_LIST = [
  { id: 1, nameMajor: 'Fashion Products' },
  { id: 2, nameMajor: 'IT Products' },
  { id: 3, nameMajor: 'Sports Products' },
  { id: 4, nameMajor: 'Others' }
];

interface ICountry {
  calling_code: string;
  flag: string;
  id: number;
  language: string;
  lookupCode: string;
  lookupCodeId: string;
  priority: string;
  value: string;
}

interface Props {
  setDate?: any;
}

const AccountSetting = ({ setDate }: Props) => {
  const [dataInf, setDataInf] = useState([] as any);
  const [loading, setLoading] = useState(false);
  const inputFile = useRef<HTMLInputElement | null>(null);

  const [form] = Form.useForm();

  const [coordinates, setCoordinates] = useState<{
    lat: number;
    lng: number;
  }>({
    lat: 0,
    lng: 0
  });

  const [searchValue, setSearchValue] = useState<string>('');
  const [licenseUrl, setLicenseUrl] = useState<string>('');
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [countryCode, setCountryCode] = useState<string>('');

  /*--------------------------get api detail inf---------------*/

  const getInfo = async () => {
    const dataIn = await pageWarehouseService.getInfoAccount();
    setDataInf(dataIn.data);
    setDate(dataIn.data?.created_at);
  };

  useEffect(() => {
    getInfo();
  }, [dataInf.id]);

  useEffect(() => {
    const major: any[] = [];
    dataInf.majorStorageProducts?.map((item: any) => {
      major.push(item?.id);
    });
    if(!!dataInf?.googleMapAddress){
    setSearchValue(dataInf?.googleMapAddress)
    }
    form.setFieldsValue({
      name: dataInf.name,
      managerName: dataInf.managerName,
      phoneNumber: dataInf.phoneNumber,
      email: dataInf.email,
      countryName: dataInf.countryName,
      postalCode: dataInf.postalCode,
      country: dataInf.country,
      city: dataInf.city,
      state: dataInf.state,
      googleMapAddress: dataInf?.googleMapAddress,
      detailAddress: dataInf?.detailAddress,
      detailAddress2: dataInf?.detailAddress2,
      scaleArea: dataInf.scaleArea,
      scaleAreaUnit: dataInf.scaleAreaUnit,
      specialCargoStorage: dataInf.specialCargoStorage === true ? 'YES' : 'NO',
      websiteUrl: dataInf.websiteUrl,
      majorStorageProduct: major,
      description: dataInf.description,
      businessLicense: dataInf.license?.fileName,
      imgUrls: dataInf?.images,
      countryCode: dataInf?.countryCode,
      rePassword: ''
    });
    setLicenseUrl(dataInf.license?.fileName);
    setFileList(dataInf?.images);
    // setCountryCode(dataInf?.countryCode); test
    setCountryCode(dataInf?.countryCode);
  }, [dataInf.id]);

  //--------------------------------------------------- Handle Calling Google API
  const {
    suggestions: { status, data },
    setValue,
    clearSuggestions
  } = usePlacesAutocomplete({
    debounce: 300
  });

  const ref = useOnclickOutside(() => {
    clearSuggestions();
  });

  const handleInput: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (form.getFieldError('googleMapAddress').length === 0) {
      setCoordinates({
        lat: 0,
        lng: 0
      });
      form.setFieldsValue({
        postalCode: '',
        country: '',
        googleMapAddress: '',
        detailAddress: '',
        city: '',
        state: ''
      });
      setValue(e.target.value);
    } else {
      clearSuggestions();
    }
    setSearchValue(e.target.value);
  };

  const handleSelectAddr =
    ({ description }: AutocompletePrediction) =>
    async () => {
      setValue(description, false);
      clearSuggestions();

      const results = await getGeocode({ address: description });
      const { lat, lng } = getLatLng(results[0]);
      setCoordinates({
        lat,
        lng
      });
      setSearchValue(description);
      form.setFieldsValue({
        googleMapAddress: description
      });
      const address_components = results[0].address_components;
      const { COUNTRY, ZIP_CODE, TOWN, CITY, STATE } =
        placesAutocomplete.getAddressComponent(address_components, [
          'COUNTRY',
          'TOWN',
          'CITY',
          'STATE',
          'ZIP_CODE',
          'NEAREST_ROAD'
        ]);

      form.setFieldsValue({
        detailAddress: results[0].formatted_address.split(',')[0]!,
        country: COUNTRY!,
        postalCode: ZIP_CODE!,
        state: STATE ?? CITY!,
        city: TOWN ?? CITY!
      });
    };

  const renderSuggestions = () =>
    data.map((suggestion: any) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text }
      } = suggestion;
      return (
        <li key={place_id} onClick={handleSelectAddr(suggestion)}>
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </li>
      );
    });

  // End Handle Calling Google API

  // Set Props for Upload component

  const validateFileType = (
    { type }: UploadFile,
    allowedTypes: string[] = ['image/jpeg', 'image/png']
  ) => {
    return allowedTypes.includes(type!);
  };

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    onChange: ({ fileList: newFileList }) => {
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      const isAllowedType = validateFileType(file);
      if (!isAllowedType) {
        message.error(`${file.name} is not JPEG file`);
        return false;
      }
      setFileList((prev) => {
        if (prev.length < 3) {
          return [...prev, file];
        }
        return prev;
      });
      setFileList([...fileList, file]);
      return false;
    },
    fileList
  };

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  /////----------------------------------------business lisence-------------------------
  const handleUploadBusinessFiles = (files: any) => {
    setLicenseUrl(files[0]?.name);
    form.setFieldsValue({
      businessLicense: files[0]
    });
  };

  const handleBusinessLicenseEvent = (e: any) => {
    const chosenFilesBusinessLicense = Array.prototype.slice.call(e);
    handleUploadBusinessFiles(chosenFilesBusinessLicense);
  };
  /*-------------------------------------------*/

  const handleEdit = async (values: any) => {
    try {
      setLoading(true);
      const body = {
        name: values.name,
        managerName: values.managerName,
        countryCode: countryCode,

        phoneNumber: values.phoneNumber,
        images: [] as any,

        newPassword: values.password,
        reNewPassword: values.rePassword,
        email: values.email,
        license: 0,

        countryName: values.countryName,
        specialCargoStorage:
          values.specialCargoStorage === 'YES' ? true : false,
        scaleArea: values.scaleArea,
        scaleAreaUnit: values.scaleAreaUnit,
        websiteUrl: values.websiteUrl,
        majorStorageProducts: values.majorStorageProduct,

        detailAddress: values.detailAddress,
        detailAddress2: values.detailAddress2,
        googleMapAddress: values.googleMapAddress,
        country: values.country || '',
        city: values.city || '',
        state: values.state || '',
        postalCode: values.postalCode || '',
        description: values.description
      };

      // setLoading(true);
      const fileIdArr = fileList.map((item: any) => item.id);

      ///get imgUrl =====================>
      const formData = new FormData();

      const fill = fileList.filter((item: any) => !item.id);

      if (fill.length === 0) {
        body.images = fileIdArr;
      } else {
        for (let i = 0; i < fill.length; i++) {
          formData.append('files', fill[i].originFileObj as any);
        }
        const uploadImg = await signUpServices.postUploadImg(formData);
        for (let i = 0; i < uploadImg.data.length; i++) {
          fileIdArr.push(uploadImg.data[i].id);
        }
        const mapId = fileIdArr.filter((item: any) => !!item);

        body.images = mapId;
      }

      // get =========================imgLicense
      if (licenseUrl === dataInf.license?.fileName) {
        body.license = dataInf.license?.id;
      } else {
        const formDataLicense = new FormData();
        formDataLicense.append('file', values.businessLicense);
        const licenseResponse = await signUpServices.postUploadLicense(
          formDataLicense
        );
        body.license = licenseResponse.data?.license.id;
      }

      // get api updated
      await pageWarehouseService.postUpdateInfo(body);
      message.success('Update Info success!');
    } catch (error: any) {
      const { data } = error?.response;
      if (data && data?.message) {
        message.error(data?.message[0]);
      }
    } finally {
      setLoading(false);
    }
  };
  /*------------------------------------------country code-------------------------------------------------------*/

  return (
    <Spin spinning={loading}>
      <div className="wrapAccountSet">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleEdit}
          encType="multipart/form-data"
          initialValues={{
            name: '',
            managerName: '',
            phoneNumber: '',
            password: '',
            email: '',
            countryName: '',
            specialCargoStorage: '',
            scaleArea: '',
            scaleAreaUnit: '',
            websiteUrl: '',
            majorStorageProduct: [],

            detailAddress: '',
            googleMapAddress: '',
            country: '',
            postalCode: '',
            description: '',
            // countryCode: countryCode,
            businessLicense: '',
            imgUrls: [],
            rePassword: ''
          }}
        >
          <Row>
            <Col span={8} style={{ paddingRight: 16 }}>
              <Form.Item
                label="Warehouse name"
                name="name"
                rules={[
                  { required: true, message: 'Warehouse name is required' },
                  {
                    pattern: new RegExp(/^[A-Za-z\s][A-Za-z0-9\s]*$/),
                    message: 'Only English can be entered'
                  }
                ]}
              >
                <Input className="border-input" />
              </Form.Item>
              <Form.Item
                label="Warehouse manager name"
                name="managerName"
                rules={[
                  {
                    required: true,
                    message: 'Warehouse manager name is required'
                  },
                  {
                    pattern: new RegExp(/^[A-Za-z\s][A-Za-z0-9\s]*$/),
                    message: 'Only English can be entered'
                  }
                ]}
              >
                <Input className="border-input" />
              </Form.Item>

              <Form.Item>
                <CountryPhoneInput
                  placeholder="Please enter number only"
                  title="Phone number"
                  name="phoneNumber"
                  defaultCode={countryCode}
                  onchange={(value) => {
                    setCountryCode(`${value}`);
                  }}
                  phoneNumberRules={[
                    {
                      required: true,
                      message: 'Phone number is required'
                    }
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item
                label="Warehouse Image"
                style={{ marginBottom: '5px' }}
                name="imgUrls"
                valuePropName="attachment"
                getValueFromEvent={normFile}
                rules={[
                  { required: true, message: 'Warehouse Image is required' },
                  {
                    max: 4,
                    message: 'Only 4 attachments are allowed',
                    type: 'array'
                  }
                ]}
              >
                <Upload
                  {...props}
                  multiple
                  fileList={fileList}
                  listType="picture-card"
                  className="uploadImg"
                  accept=".png, .jpg, .jpeg"
                  maxCount={4}
                  showUploadList={{
                    showPreviewIcon: false
                  }}
                >
                  {fileList?.length < 4 ? (
                    <div>
                      <PlusOutlined />
                      <div style={{ marginTop: 8 }}>Upload</div>
                    </div>
                  ) : null}
                </Upload>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={8} style={{ paddingRight: 16 }}>
              <Form.Item
                label="E-mail"
                name="email"
                rules={[
                  {
                    required: true,
                    type: 'email',
                    message: 'The input is not valid E-mail!'
                  }
                ]}
              >
                <Input className="border-input" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Business license"
                name="businessLicense"
                rules={[
                  { required: true, message: 'Business licensee is required' }
                ]}
              >
                <Input.Group compact>
                  <Input
                    style={{ width: 'calc(100% - 150px)' }}
                    className="border-input"
                    value={licenseUrl}
                    readOnly
                    placeholder="Only upload png, jpg, pdf files."
                  />
                  <Button
                    className="ant-btn attach-btn"
                    type="primary"
                    onClick={() => inputFile?.current?.click()}
                  >
                    Attachment
                  </Button>
                  <input
                    ref={inputFile}
                    className="d-none"
                    type="file"
                    accept=".pdf, .png, .jpg, .jpeg"
                    onChange={(event: any) =>
                      handleBusinessLicenseEvent(event.target.files)
                    }
                  />
                </Input.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ paddingRight: 16 }}>
              <Form.Item
                className="pass"
                name="password"
                label="Password"
                rules={[
                  {
                    // required: true,
                    pattern: new RegExp(
                      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/
                    ),
                    message: 'Please check your password'
                  }
                ]}
              >
                <Input.Password
                  className="border-input"
                  style={{ padding: '0 11px' }}
                  placeholder="Please enter the new password"
                />
              </Form.Item>
            </Col>
            <Col span={3} style={{ paddingRight: 16 }}>
              <Form.Item
                label="Scale / Area"
                name="scaleArea"
                style={{
                  display: 'inline-block'
                }}
                rules={[
                  {
                    pattern: new RegExp(/^[+-]?\d+(\.\d+)?$/),
                    message: 'Please input number'
                  },
                  {
                    required: true,
                    message: ' Scale area is required'
                  }
                ]}
              >
                <Input className="border-input" min={0} />
              </Form.Item>
            </Col>
            <Col span={3} style={{ paddingRight: 16 }}>
              <div style={{ marginTop: '37px' }}></div>
              <Form.Item
                className="signDropStorage"
                name="scaleAreaUnit"
                rules={[
                  {
                    required: true,
                    message: 'Please select scale/ area unit!'
                  }
                ]}
              >
                <Select defaultValue="Select" className="border-input">
                  <Option value="km²">km²</Option>
                  <Option value="ha">ha</Option>
                  <Option value="ft²">ft²</Option>
                  <Option value="yd²">yd²</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={8} style={{ paddingRight: 16 }}>
              <Form.Item
                className="newpass"
                name="rePassword"
                label="Confirm Password"
                dependencies={['password']}
                hasFeedback
                rules={[
                  {
                    required:
                      form.getFieldValue('rePassword') !==
                      form.getFieldValue('password')
                        ? true
                        : false,
                    message: 'Please enter your re-password!'
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error('Please check your password.')
                      );
                    }
                  })
                ]}
              >
                <Input.Password
                  className="border-input"
                  placeholder="Please enter the new password again"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Row>
                <Col span={12} style={{ paddingRight: 9 }}>
                  <Form.Item
                    label="Special cargo storage"
                    style={{ width: '100%' }}
                    className="signDropStorage"
                    name="specialCargoStorage"
                    rules={[
                      {
                        required: true,
                        message: 'Please select cargo storage'
                      }
                    ]}
                  >
                    <Select defaultValue="Select" className="border-input">
                      <Option value="true">YES</Option>
                      <Option value="false">NO</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col span={4} style={{ paddingRight: 16 }}>
              <Form.Item
                label="Warehouse Country/Address"
                name="country"
                rules={[{ required: true, message: 'Address is required' }]}
              >
                <Input
                  className="border-input"
                  disabled
                  placeholder="Country/Region"
                />
              </Form.Item>
            </Col>
            <Col span={11}>
              <Form.Item
                label="　"
                style={{
                  display: 'inline-block',
                  width: '100%',
                  borderRadius: '7px'
                }}
                name="googleMapAddress"
                className="search-address"
              >
                <div ref={ref}>
                  <Input
                    defaultValue="1235"
                    className="border-input"
                    value={searchValue}
                    onChange={handleInput}
                    placeholder="Search Places ..."
                  />
                  {status === 'OK' && <ul>{renderSuggestions()}</ul>}
                </div>
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ marginTop: '5px' }}>
            <Col span={8} style={{ paddingRight: '11px' }}>
              <Form.Item name="detailAddress2">
                <Input
                  className="border-input"
                  placeholder="More detail adress"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="detailAddress">
                <Input
                  className="border-input"
                  disabled
                  placeholder="Apartment, suite, unite, building, floor, etc."
                />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ marginTop: '5px' }}>
            <Col span={16}>
              <Row>
                <Col span={8} style={{ paddingRight: '11px' }}>
                  <Form.Item name="city">
                    <Input
                      className="border-input"
                      disabled
                      placeholder="Town/City"
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ paddingRight: '11px' }}>
                  <Form.Item name="state">
                    <Input
                      className="border-input"
                      disabled
                      placeholder="County/State"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="postalCode">
                    <Input className="border-input" />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ paddingRight: 11 }}>
              <Form.Item label="Website URL(Select Option)" name="websiteUrl">
                <Input className="border-input" placeholder="Post code" />
              </Form.Item>
            </Col>
            <Col span={8} style={{ position: 'relative' }}>
              <Form.Item
                className="majorSign"
                name="majorStorageProduct"
                label="Major storage product"
                rules={[
                  {
                    max: 3,
                    type: 'array',
                    message: 'Choose at least one item and upto 3 items',
                    min: 1,
                    required: true
                  }
                ]}
                style={{ width: '100%' }}
              >
                <Select
                  className="border-input multi-select"
                  placeholder="Up to 3"
                  mode="tags"
                  size={'middle'}
                >
                  {MAJOR_PRODUCT_TYPE_LIST.map((item: any) => (
                    <Option key={item.id} value={item.id}>
                      {item.nameMajor}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <DownOutlined className="icon-major" />
            </Col>
          </Row>
          <Row>
            <Col span={16}>
              <Form.Item
                label="Detail description"
                name="description"
                rules={[
                  {
                    required: true,
                    message: 'Comment is required'
                  },
                  {
                    max: 2000,
                    message: 'Character must be less than 2000!'
                  }
                ]}
              >
                <Input.TextArea
                  style={{ resize: 'none' }}
                  autoSize={{ minRows: 3, maxRows: 6 }}
                  placeholder="Up to 2000 characters can be entered."
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ display: 'table', textAlign: 'end' }}>
              <div
                style={{
                  display: 'table-cell',
                  verticalAlign: 'bottom'
                }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    backgroundColor: '#2B2C51',
                    border: 'none',
                    borderRadius: '5px'
                  }}
                >
                  Request for modification
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </Spin>
  );
};

export default AccountSetting;
